import React from "react";
import {useForm} from "react-hook-form";
import FormProgress from "@/modules/front/ReservationExternal/FormProgress";
import moment from "moment";


const ReservationExternalStep2 = (props) => {
    const [termsAccepted, setTermsAccepted] = React.useState(false);
    const [gdprAccepted, setGdprAccepted] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSubmit = () => {
        if (!termsAccepted) {
            setError('Pro pokračování je nutné souhlasit s obchodními podmínkami.');
            return;
        }
        if (!gdprAccepted) {
            setError('Pro pokračování je nutné souhlasit se zpracováním osobních údajů.');
            return;
        }
        props.onSubmit();
    }

    return <>
        <FormProgress
            currentStep={3}/>
        <h2 className={'h5 mt-3 text-uppercase'}>Rezervace</h2>
        <div className="row">
            <div className={'col-md-12 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold mb-3'}>
                        Položky:
                    </div>
                    <div className={'dotted-line mb-2'}>
                        <div>
                            {props.itemTitle}
                        </div>
                        <div>
                            {props.itemPrice} Kč
                        </div>
                    </div>
                    {props.selectedServices && props.selectedServices.map((service) => {
                        return <div className={'dotted-line mb-2'} key={service.id}>
                            <div>
                                {service.name}
                            </div>
                            <div>
                                {service.price} Kč
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Vyzvednutí:
                    </div>
                    <div>
                        {moment(props.dateFrom).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Vrácení:
                    </div>
                    <div>
                        {moment(props.dateTo).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
        </div>
        <h2 className={'h5 mt-3 text-uppercase'}>Osobní údaje</h2>
        <div className="row">
            <div className={'col-md-4 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Jméno:
                    </div>
                    <div>
                        {props.personalData.firstname}
                    </div>
                </div>
            </div>
            <div className={'col-md-4 mt-2'}>
                <div className={'bg-light p-3'}>

                    <div className={'fw-bold'}>
                        Příjmení:
                    </div>
                    <div>
                        {props.personalData.lastname}
                    </div>
                </div>
            </div>
            <div className={'col-md-4 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Datum narození:
                    </div>
                    <div>
                        {props.personalData.birthdate}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        E-mail:
                    </div>
                    <div>
                        {props.personalData.email}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Telefon:
                    </div>
                    <div>
                        {props.personalData.phone}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Adresa
                    </div>
                    <div>
                        {props.personalData.address}, {props.personalData.zip} {props.personalData.city}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        Počet osob:
                    </div>
                    <div>
                        {props.personalData.persons}
                    </div>
                </div>
            </div>
        </div>

        <div className={'row'}>
            <div className={'col-md-8 mt-3'}>
                <div className={'form-check mt-4'}>
                    <input className="form-check-input" type="checkbox" id="termsAccepted" value={termsAccepted}
                           onChange={(e) => setTermsAccepted(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="termsAccepted">
                        Souhlasím s <a href={props.termsUrl} target={'_blank'}>obchodními podmínkami</a>.
                    </label>
                </div>
                <div className={'form-check mt-2'}>
                    <input className="form-check-input" type="checkbox" id="gdprAccepted" value={gdprAccepted}
                           onChange={(e) => setGdprAccepted(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="gdprAccepted">
                        Souhlasím se <a href={props.gdprUrl} target={'_blank'}>zpracováním osobních údajů</a>.
                    </label>
                </div>
            </div>
            <div className={'col-md-4 mt-3 text-md-end'}>
                <div className={'pt-3 fs-5'}>
                    Celkem: {props.totalPrice} Kč
                </div>
            </div>
        </div>

        {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}

        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={() => props.setStep(2)}><i
                className="fas fa-chevron-left me-3"></i> Zpět</span>
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={handleSubmit}>Odeslat rezervaci<i
                className="fas fa-check ms-3"></i></span>
        </div>
    </>;

};

export default ReservationExternalStep2;